module.exports = __webpack_public_path__ + "media/images/logos/logo-works-236d86e654656728bd7fa63b1fd17281.svg";